/* comment-emoji.js — Emoji-Leiste für das Kommentarformular.

   Klinkt sich selbst ein, statt Shopifys {% form 'new_comment' %}-Markup anzufassen:
   das Formular wird von Shopify generiert und kann sich ändern.

   Kein Tracking, keine Fremdressource, deshalb consent-frei. Die Emojis sind reine
   Unicode-Zeichen, es wird nichts nachgeladen. */
(function () {
  'use strict';

  var EMOJIS = ['🤍', '✨', '😍', '🙌', '👏', '🌙', '💤', '🌿', '🔥', '😊', '💛', '🫶'];

  function insertAtCursor(field, text) {
    var start = field.selectionStart;
    var end = field.selectionEnd;

    if (typeof start !== 'number') {
      field.value += text;
    } else {
      field.value = field.value.slice(0, start) + text + field.value.slice(end);
      var pos = start + text.length;
      field.setSelectionRange(pos, pos);
    }
    // damit Shopifys eigene Validierung den neuen Wert mitbekommt
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.focus();
  }

  function build(field) {
    if (field.dataset.emojiBar === 'on') return;
    field.dataset.emojiBar = 'on';

    var bar = document.createElement('div');
    bar.className = 'comment-emoji';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', document.documentElement.lang.indexOf('de') === 0
      ? 'Emoji einfügen'
      : 'Insert emoji');

    EMOJIS.forEach(function (e) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'comment-emoji__btn';
      b.textContent = e;
      b.setAttribute('aria-label', e);
      b.addEventListener('click', function () { insertAtCursor(field, e); });
      bar.appendChild(b);
    });

    field.parentNode.insertBefore(bar, field.nextSibling);
  }

  function init() {
    var field = document.querySelector('.comment-form textarea');
    if (field) build(field);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
